import React, { Component } from "react";

export default class PageSubmitButton extends Component {
  	
	render () {
									
	    return (
		    
		    <div className="submit-button">Submit</div>
		)
	}
}
